import * as React from 'react'
import { useState, useEffect } from 'react'
import Map from 'react-map-gl'
import { Marker } from 'react-map-gl'
import GeocoderControl from './geocoder-control'

// eslint-disable-next-line
const TOKEN = process.env.REACT_APP_MAPS_KEY
const initialViewState = {
  latitude: 23.866980789984908,
  longitude: -102.48693758189374,
  zoom: 4
}

export default function GeocoderMap(props) {
  const { coordinates } = props
  const [viewport, setViewport] = useState(initialViewState)

  useEffect(() => {
    if (coordinates?.lat && coordinates?.long && +coordinates.lat !== 23.866980789984908 && +coordinates.long !== -102.48693758189374) {
      setViewport((prev) => ({
        ...prev,
        latitude: Number(coordinates.lat),
        longitude: Number(coordinates.long),
        zoom: 16
      }));
    }
  }, [coordinates.lat, coordinates.lng]);

  return (
    <>
      <Map
        {...viewport}
        onMove={(evt) => setViewport(evt.viewState)}
        mapStyle="https://api.maptiler.com/maps/basic-v2/style.json?key=zQZLhSau046UB7IrjeYK"
        mapboxAccessToken={TOKEN}
      >
        {
          props.search && <GeocoderControl mapboxAccessToken={TOKEN} position="top-left" addressRefs={props.addressRefs} coordinates={coordinates} />
        }
        {
          // Lat and Long default, so is not necessary render the component if the original item doesnt have coordinates
          !props.search && coordinates?.lat && coordinates?.long && +coordinates.lat !== 23.866980789984908 && +coordinates.long !== -102.48693758189374 && <Marker latitude={coordinates.lat} longitude={coordinates.long} />
        }
      </Map>
    </>
  );
}